

import ReportCheckListFile from './ReportCheckListFile.vue'

function addOrRemoveValue (array, value, add) {
  if (add) {
    if (!array.includes(value)) {
      array.push(value)
    }
  } else {
    const index = array.indexOf(value)
    if (index > -1) {
      array.splice(index, 1)
    }
  }
}

export default {
  extends: ReportCheckListFile,
  computed: {
    required: function () { // @override
      return !!(!this.readonly && this.technologicalOperation && this.technologicalOperation.required && this.technologicalOperation.resultsRequired)
    },
    validValue: function () {
      if (!this.readonly && this.required) {
        return !this.filesGroup.empty
      }
      return true
    }
    // beaconQRInvalidFormat: function () {
    //   const invalidFormatResultValue = this.getResultValueForOperation(this.getTechnologicalOperation(), 'beaconQRInvalidFormatRes', 'beaconQRInvalidFormat')
    //   return !!(invalidFormatResultValue && invalidFormatResultValue.value)
    // }
  },
  watch: {
    'filesGroup.empty': {
      handler: function () {
        this.$nextTick(() => this.validate())
      },
      immediate: true
    }
    // beaconQRInvalidFormat: {
    //   handler: function (value) {
    //     const warnings = this.warnings
    //     const message = 'Неизвестный формат данных QR-кода'
    //     addOrRemoveValue(warnings, message, value)
    //   },
    //   immediate: true
    // }
  },
  created: function () {
    this.singular = true // @override
    this.rules = [val => this.validValue]

    this.updateWarnings()
  },
  mounted: function () {
    this.validate()
  },
  methods: {
    validate: function () {
      if (this.$refs.field) {
        return this.$refs.field.validate()
      }
    },
    updateWarnings: function () {
      const beaconQRInvalidFormatMessage = 'Неизвестный формат данных QR-кода'
      const qrNotFoundMessage = 'QR-код не обнаружен'

      let beaconQRInvalidFormat = false
      let qrNotFound = false
      for (const fileWrapper of this.filesGroup.files) {
        const additional = fileWrapper.document && fileWrapper.document.additional
        if (additional) {
          addOrRemoveValue(fileWrapper.props.warnings, beaconQRInvalidFormatMessage, additional.beaconQRInvalidFormat)
          if (additional.beaconQRInvalidFormat) {
            beaconQRInvalidFormat = true
          }
          addOrRemoveValue(fileWrapper.props.warnings, qrNotFoundMessage, additional.qrNotFound)
          if (additional.qrNotFound) {
            qrNotFound = true
          }
        }
      }

      const warnings = this.warnings
      addOrRemoveValue(warnings, beaconQRInvalidFormatMessage, beaconQRInvalidFormat)
      addOrRemoveValue(warnings, qrNotFoundMessage, qrNotFound)
    },

    // @override
    onFinishUploadSuccess: function ({ document, filesGroup, fileWrapper }) {
      this.updateWarnings()

      const validBeaconSerialNumber = document.additional && document.additional.beaconSerialNumber
      if (validBeaconSerialNumber) {
        // this.updateInitialResultValue(true)

        const serialNumberInPhotoResultValue = this.getSerialNumberInPhotoResultValue()
        if (serialNumberInPhotoResultValue) {
          serialNumberInPhotoResultValue.value = document.additional.beaconSerialNumber

          // const initialSerialNumberInPhotoResultValue = this.getSerialNumberInPhotoResultValue(true)
          // if (initialSerialNumberInPhotoResultValue) {
          //   initialSerialNumberInPhotoResultValue.value = document.additional.beaconSerialNumber
          // }
        }
      }

      this.setBeaconQRInvalidFormat(!validBeaconSerialNumber)
    },
    // @override
    onFinishRemoveFile: function ({ file, filesGroup }) {
      this.updateWarnings()

      const document = file.document
      if (document.additional && (document.additional.qrText || document.additional.beaconSerialNumber)) {
        this.updateInitialResultValue(false)

        const serialNumberInPhotoResultValue = this.getSerialNumberInPhotoResultValue()
        if (serialNumberInPhotoResultValue && (serialNumberInPhotoResultValue.value === document.additional.qrText || serialNumberInPhotoResultValue.value === document.additional.beaconSerialNumber)) {
          serialNumberInPhotoResultValue.value = null

          const initialSerialNumberInPhotoResultValue = this.getSerialNumberInPhotoResultValue(true)
          if (initialSerialNumberInPhotoResultValue) {
            initialSerialNumberInPhotoResultValue.value = null
          }
        }
      }

      this.setBeaconQRInvalidFormat(null)
    },

    updateInitialResultValue: function (done) {
      const workInitial = this.getWork(true)
      const technologicalOperationInitial = this.getTechnologicalOperation(true)
      if (technologicalOperationInitial) {
        const resultValue = this.resultValue
        const resultValueInitial = this.getResultValueForOperation(technologicalOperationInitial, 'beaconQRPhotoRes', 'beaconQRPhoto')
        if (resultValue && resultValueInitial) {
          resultValueInitial.value = JSON.parse(JSON.stringify(resultValue.value))

          technologicalOperationInitial.done = done // TODO вычислять
          workInitial.done = done // TODO вычислять
        }
      }
    },
    setBeaconQRInvalidFormat: function (value) {
      const invalidFormatResultValue = this.getResultValueForOperation(this.getTechnologicalOperation(), 'beaconQRInvalidFormatRes', 'beaconQRInvalidFormat')
      if (invalidFormatResultValue) {
        invalidFormatResultValue.value = value

        const invalidFormatResultValueInitial = this.getResultValueForOperation(this.getTechnologicalOperation(true), 'beaconQRInvalidFormatRes', 'beaconQRInvalidFormat')
        invalidFormatResultValueInitial.value = value
      }
    },

    // ---

    getWork: function (initial) {
      const technologicalOperation = this.getTechnologicalOperation(false)
      return initial ? technologicalOperation._work._initial : technologicalOperation._work
    },
    getTechnologicalOperation: function (initial) {
      const technologicalOperation = this.resultValue._workResultsType._technologicalOperation
      if (!initial) {
        return technologicalOperation
      }
      const workInitial = technologicalOperation._work._initial
      if (workInitial && workInitial.technologicalOperations) {
        for (const operation of workInitial.technologicalOperations) {
          if (operation.key === technologicalOperation.key) {
            return operation
          }
        }
      }
      return null
    },
    getResultValueForOperation: function (technologicalOperation, workResultKey, resultValueCode) {
      for (const workResultsType of technologicalOperation.workResultsTypes) {
        if (workResultsType && workResultsType.resultValues && workResultsType.key === workResultKey) {
          for (const resultValue of workResultsType.resultValues) {
            if (resultValue && resultValue.code === resultValueCode) {
              return resultValue
            }
          }
        }
      }
      return null
    },

    getSerialNumberInPhotoResultValue: function (initial) {
      const technologicalOperation = this.getTechnologicalOperation(initial)
      if (technologicalOperation) {
        return this.getSerialNumberInPhotoResultValueForOperation(technologicalOperation)
      }
      return null
    },
    getSerialNumberInPhotoResultValueForOperation: function (technologicalOperation) {
      let serialNumberInPhotoResultValue
      for (const workResultsType of technologicalOperation.workResultsTypes) {
        if (workResultsType && workResultsType.resultValues && workResultsType.key === 'beaconSerialNumberInPhotoRes') {
          for (const resultValue of workResultsType.resultValues) {
            if (resultValue && (resultValue.code === 'beaconSerialNumberInPhoto' || resultValue.code === 'serialNumber')) {
              serialNumberInPhotoResultValue = resultValue
              break
            }
          }
        }
      }
      return serialNumberInPhotoResultValue
    }
  }
}

